<template>
  <div class="app">
    <div class="app-content">
      <t-upper-nav />
      <main
        class="tw-overflow-y-aut tw-flex-1 tw-bg-primary-grey-25 tw-p-4 max-lg:tw-ml-14"
      >
        <div class="tw-w-full">
          <t-page-header
            :product-links="productLinks"
            :user-links="userLinks"
            :data-test-id="'header-user-menu'"
          />
          <router-view />
        </div>
      </main>
      <cl-footer
        :other-products-text="$t('text-block-other-products')"
        :try-now-text="$t('action-text-try-now')"
        :msp-name="getOrganisationBranding.name ?? undefined"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { storeToRefs } from "pinia";

import { useBrandingStore } from "@/store/branding.store";

import TPageHeader from "@/components/TPageHeader";
import TUpperNav from "@/components/TUpperNav/TUpperNav.vue";

import type {
  ProductLink,
  UserLink,
} from "@/components/TPageHeader/TPageHeader.types";

type SelectedMsp = {
  id?: string;
  name?: string;
  email?: string;
  roles?: string[];
  uuid?: string;
};

type SelectedAccount = {
  uuid?: string;
  name?: string;
  type_name?: string;
};

const store = useStore();
const brandingStore = useBrandingStore();

const { organisationBranding: getOrganisationBranding } =
  storeToRefs(brandingStore);

const selectedMsp = computed(
  (): SelectedMsp | null => store.getters["authentication/selectedMsp"],
);

const selectedAccount = computed(
  (): SelectedAccount | null => store.getters["authentication/selectedAccount"],
);

const productLinks: ProductLink[] = [];
const userLinks: UserLink[] = [];

onMounted(async () => {
  await brandingStore.getBranding({
    organisationUuid: selectedMsp.value?.uuid || selectedAccount.value?.uuid,
  });
});
</script>
